import {Dimensions, Platform, StyleSheet} from 'react-native';

const windowDim = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

export const formsStyles = StyleSheet.create({
  line: {
    flex: 1,
    borderBottomColor: '#e0e0e0',
    borderBottomWidth: 1,
    marginHorizontal: 10,
  },
  itemSearchIcone: {
    marginLeft: 15,
    marginTop: 15,
    width: 20,
    height: 20,
  },
  datePickerContainer: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
    minWidth: 250,
  },
  itemSearchIconeDetailContract: {
    marginLeft: 15,
    marginTop: 50,
    width: 20,
    height: 20,
  },
  webformContainMobile: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  contractWrapper: {
    width: windowDim - 24,
    maxWidth: 768,
    marginHorizontal: 16,
  },
  formContainContract: {
    paddingTop: Platform.OS === 'web' ? 48 : 5,
    paddingBottom: Platform.OS === 'web' ? 48 : 16,
    paddingHorizontal: 20,
    backgroundColor: '#fff',
    maxWidth: Platform.OS === 'web' ? '100%' : 1025,
    borderRadius: Platform.OS === 'web' ? 10 : 0,
    minHeight: windowHeight - 75,
  },
  webformContainContract: {
    display: 'flex',
    flex: 1,
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: Platform.OS === 'web' ? 0 : 0,
  },
  formContainP: {
    paddingTop: Platform.OS === 'web' ? 48 : 5,
    paddingBottom: Platform.OS === 'web' ? 20 : 16,
    paddingHorizontal: Platform.OS === 'web' ? 40 : 20,
    backgroundColor: '#fff',
    maxWidth: Platform.OS === 'web' ? 1025 : '100%',
    width: '100%',
    borderRadius: Platform.OS === 'web' ? 10 : 0,
    minHeight: '100%',
  },
  imagesLink: {
    width: 40,
    height: 40,
    resizeMode: 'contain',
  },
  itemInputStyleTextArea: {
    borderWidth: 1,
    borderColor: 'rgba(224, 224, 224, 1)',
    borderRadius: 30,
    backgroundColor: '#fff',
    color: '#000',
    fontSize: 14,
    flexDirection: 'row',
    marginTop: 10,
    paddingTop: 10,
    paddingLeft: 16,
    marginBottom: 16,
    height: 200,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
  },
  itemInputStyle: {
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 30,
    backgroundColor: '#fff',
    color: '#000',
    fontSize: 14,
    flexDirection: 'row',
    marginTop: 5,
    paddingLeft: 16,
    marginBottom: 16,
    height: 50,
    zIndex: 1000,
  },
  CountryInputStyle: {
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 30,
    backgroundColor: '#fff',
    color: '#000',
    fontSize: 14,
    flexDirection: 'row',
    marginTop: 5,
    paddingLeft: 16,
    marginBottom: 16,
    height: 50,
  },
  inputError: {
    borderColor: '#f00',
  },
  iconEye: {
    height: 20,
    width: 24,
    marginLeft: 15,
    marginTop: 13,
  },
  labelStyle: {
    color: 'rgba(29, 92, 66, 1)',
    fontSize: 11,
    fontWeight: '700',
    marginTop: 10,
    marginBottom: 5,
    textAlign: 'left',
  },
  webformContain: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
    alignItems: 'center',
    marginVertical: Platform.OS === 'web' ? 0 : 0,
    flex: 1,
  },
  formContain: {
    paddingTop: Platform.OS === 'web' ? 48 : 30,
    paddingBottom: Platform.OS === 'web' ? 48 : 70,
    paddingHorizontal: Platform.OS === 'web' ? 40 : 20,
    backgroundColor: '#fff',
    maxWidth: Platform.OS === 'web' ? 1025 : '100%',
    width: '100%',
    borderRadius: Platform.OS === 'web' ? 10 : 0,
  },
  formGroup: {
    paddingVertical: 16,
  },
  fondMobile: {
    width: windowDim / 2.1,
    height: windowHeight / 3,
    resizeMode: 'contain',
    position: 'absolute',
    right: -20,
    top: -5,
  },
  bgTrans: {
    backgroundColor: 'transparent',
  },
  profilFormInput: {
    // backgroundColor: 'rgba(240, 244, 248, 0.875)',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#CACACA',
    borderRadius: 30,
    color: '#000',
    fontSize: 14,
    flexDirection: 'row',
    fontWeight: '700',
    marginTop: 5,
    paddingLeft: 12,
    paddingRight: 12,
    marginBottom: 16,
    height: 50,
    minHeight: 50,
    maxHeight: 50,
    flex: Platform.OS === 'web' ? 1 : 0,
    minWidth: Platform.OS === 'web' ? 300 : 140,
    maxWidth: '100%',
  },
  formLogInscr: {
    backgroundColor: '#fff',
    position: 'relative',
    flex: 1,
  },
  FondMobile: {
    width: windowDim / 2.1,
    height: windowHeight / 3,
    resizeMode: 'contain',
    position: 'absolute',
    right: -20,
    top: -5,
  },
  formWebs: {
    maxWidth: 640,
  },
  webformContainChat: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
    alignItems: 'center',
    marginVertical: Platform.OS === 'web' ? 40 : 0,
    flex: 1,
    height: Platform.OS === 'web' ? windowHeight - 75 : '100%',
  },
  formContainChat: {
    height: Platform.OS === 'web' ? windowHeight - 75 : '100%',
    paddingTop: Platform.OS === 'web' ? 48 : 5,
    paddingBottom: Platform.OS === 'web' ? 48 : 16,
    paddingHorizontal: Platform.OS === 'web' ? 80 : 20,
    backgroundColor: '#fff',
    maxWidth: Platform.OS === 'web' ? 1025 : '100%',
    width: '100%',
    borderRadius: Platform.OS === 'web' ? 10 : 0,
    minHeight: windowHeight - 75,
  },
  containerLayout: {
    flex: Platform.OS === 'web' ? 1 : 0,
    justifyContent: 'space-between',
    marginBottom: 40,
  },
  containerBtn: {
    justifyContent: 'center',
    marginTop: 0,
  },
  autoComplete: {
    borderWidth: 1,
    borderColor: 'rgba(224, 224, 224, 1)',
    borderRadius: 30,
    backgroundColor: '#fff',
    color: '#000',
    fontSize: 14,
    flexDirection: 'column',
    padding: 16,
    marginBottom: 16,
  },
  autoCompleteTxt: {
    backgroundColor: '#fff',
    fontSize: 14,
    paddingHorizontal: 16,
    paddingVertical: 4,
  },
  profilInsc: {
    width: 80,
    height: 80,
    borderRadius: 40,
  },
  formContainPayment: {
    paddingTop: Platform.OS === 'web' ? 0 : 5,
    paddingBottom: Platform.OS === 'web' ? 48 : 16,
    paddingHorizontal: Platform.OS === 'web' ? 40 : 10,
    backgroundColor: '#fff',
    maxWidth: Platform.OS === 'web' ? 1025 : '100%',
    width: '100%',
    borderRadius: Platform.OS === 'web' ? 10 : 0,
    minHeight: windowHeight - 75,
  },
  paymentContain: {
    minHeight: windowHeight - 80,
    backgroundColor: '#fff',
  },
  paymentContainWeb: {
    minHeight: windowHeight - 80,
    backgroundColor: 'rgb(242, 242, 242)',
  },
});
